export class FunctionEnum {
  public static Login = "login";
  public static UpdatePass = "update_password";
  public static ResetPass = "reset_password";
  public static GetTask = "get_task";
  public static SaveTask = "save_task";
  public static UpdateTask = "update_task";
  public static DeleteTask = "delete_task";
  public static SaveLeave = "save_leave";
  public static GetProject = "get_project";
  public static GetRoles = "get_roles";
  public static GetEmpName = "get_employee_list";
  public static ReviewTask = "review_task";
  public static AssignTask = "assign_task";
  public static GetpersonList = "get_person_list";
  public static GetLeadNameList = "get_lead_name";
  public static SavePersonData = "save_person";
  public static SaveProjects = "save_projects";
  public static GetMonthlyTask = "get_monthly_task";
  public static GetPersonList = "get_person_list";
  public static GetTaskReportDetail = "get_task_report";
  public static GetMonthlyLeaveReport = "get_leave_report";
  public static GetLeaveData = "get_leave_date";
  public static GetLeadEmplyee = "get_lead_employee";
  public static GetLeadEmpTask = "get_lead_emp_task";
  public static GetProjectList = "get_project_list";
  public static deleteProject = "delete_project";
  public static saveLeaveByAdmin = "save_leave_by_admin";
  public static revokeLevae = "cancel_leave";
  public static getPersonProfile = "get_person_profile";
  public static getReviewTaskDetail = "get_review_task_detail";
  public static saveReviewTask = "save_review_task";
  public static getHolidayData = "get_holidays";
  public static saveHolidayData = "save_holidays";
  public static getAllocatedProjects = "get_allocated_project";
  public static getPersonDetail = "get_person_detail";
  public static getNotreviewedReport = "get_not_approved_task";
  public static getConsolidatedReport = "get_consolidated_report";
  public static getProjectPersonList = "get_project_person_list";
  public static saveCalendarHdr = "save_calendar_hdr";
  public static getPersonConsolidatedTaskReport = "get_consolidated_report_for_person";
  public static getClientCalender = "get_client_calendar";
  public static saveClientCalender = "save_calendar";
  public static getCalendar = "get_calendar";
  public static deleteCalendar = "delete_holiday";
  public static getPersonprojectWorkingDays = "get_person_working_days";
  public static getConsolidatedProject = "get_consolidated_project_report";
  public static removePerosnProjects = "remove_person_project";
  public static getLeadAllocationProjects = "get_lead_allocation_project";
  public static getProjectEmpTaskEfforts = "get_emp_task_efforts";
  public static getCurrentAllocationReport = "get_current_allocation";
  public static getEmployeesWorkReports = "get_employees_report";
  public static getProjectListByPersonIds = "get_projects_by_ids";
  public static saveImportedTimesheet = "save_imported_timesheet";

}
